import React, { Component } from 'react'
import Landing from './pages/Landing'
import About from './pages/About'
import { BrowserRouter, Route } from 'react-router-dom'
import Shop from './shop/Shop'
import Header from './Header'
import ChatBot from './chatBot/ChatBot'
import ReactBot from './chatBot/ReactBot'
import './styles.css'
import Footer from './pages/Footer'
import Sidebar from './pages/Sidebar'
import { Button } from 'react-materialize'
import Login from './pages/Login'

class App extends Component {
  state = {
    chat1: true,
    chat2: true,
    loginState: false,
    enableFloating: false
  }


  componentDidMount() {
    if (process.env.NODE_ENV === 'development') {
      this.setState({
        loginState: true
      })
    }
  }


  login = () => {
    this.setState({
      loginState: true
    })
  }
  enableFloating = () => {
    this.setState( (prev) => ({
      enableFloating: !prev.enableFloating
    }))
  }

  logout = () => {
    this.setState({
      loginState: false
    })
  }

  openChat1 = () => {
    this.setState(prev => ({
      chat1: !prev.chat1
    }))
  }
  openAll = () => {
    this.setState(prev => ({
      chat1: true,
      chat2: true
    }))
  }

  openChat2 = () => {
    this.setState(prev => ({
      chat2: !prev.chat2
    }))
  }

  renderNoChat = () => {
    return (
      <div>
        <div className="col s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Welcome to inChatBot Sample App</p>
              </div>
              <div className="card-action">
                <Button onClick={this.openAll}>Open Chat</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { chat1, chat2, loginState} = this.state
    const hasPermission = loginState
    return (
      <div>
        <BrowserRouter>
          <div>
            <Header />
            <Sidebar
              chatState={this.state}
              openChat1={this.openChat1}
              openChat2={this.openChat2}
              enableFloating={this.enableFloating}
              hasPermission={hasPermission}
              enableFloatingState={this.state.enableFloating}
            />
            <Route exact path="/inReactBot" component={Landing} />
            <Route exact path="/" component={Landing} />
            <div className="container container-height">
              <Route exact path="/about" component={About} />
              <Route exact path="/shop" component={Shop} />
              <Route exact path="/login" component={() => {
                return (
                  <div>
                    <Login loginState={this.state.loginState} login={this.login} logout={this.logout} />
                  </div>
                )
              }} />
              {hasPermission && chat1 && <ChatBot />}
              {chat2 && <ReactBot
                enableFloating={this.state.enableFloating}
              />}

              {!chat1 && !chat2 && this.renderNoChat()}

              {!chat2 && !hasPermission && this.renderNoChat()}
            </div>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    )
  }
}

export default App
